import React from "react";

const PageHeaderRowSearch = (props) => {
  return (
    <div id="page-header" className={props.extraClasses}>
      <div id="page-title-container">
        <p className="page-pretitle">{props.pretitle}</p>
        <div className="display-flex">
          {typeof props.h1 === 'string' ? <h1 className="page-title">{props.h1}</h1> : props.h1}
          {props.actionButtons && props.actionButtons}
        </div>
      </div>

      {props.rightColumn}
    </div>
  );
};

export default PageHeaderRowSearch;
